const summaries = state => state.summaries

const currentSummary = state => state.currentSummary

const currentSecondaryFilters = state => state.currentSecondaryFilters

const healthEvents = state => state.healthEvents

const sortBy = state => state.sortBy

const sortOrder = state => state.sortOrder

const filters = state => state.filters

export default {
  healthEvents,
  summaries,
  currentSummary,
  currentSecondaryFilters,
  sortBy,
  sortOrder,
  filters
}
